export const isMobile = () => {
  return document.body.clientWidth < 1256;
};
